import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import orders from "./reducers/orders";
import portfolio from "./reducers/portfolio";
// import modals from "./reducers/modals";
import debounce from 'lodash.debounce';
import marketwatch from "./reducers/watchlist";
// import configs from "./reducers/configs";
import { batchedSubscribe } from 'redux-batched-subscribe';
// import error from "./reducers/error";
import profile from "./reducers/profile";
import funds from "./reducers/funds";
import themeReducer from './reducers/themeReducer';
import marginReducer from './reducers/margin';
import brokerageReducer from './reducers/brokerage';
import socketMessageReducer from './reducers/socketMessage';
import alerts from './reducers/alerts';
import notificationBadge from './reducers/notificationBadge';

const debounceNotify = debounce(notify => notify());

const composeEnhancers =
  (process.env.NODE_ENV === "development" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;


const rootReducer = combineReducers({
  alerts,
  orders,
  marketwatch,
  portfolio,
  profile,
  funds,
  theme: themeReducer,
  margin: marginReducer,
  brokerage: brokerageReducer,
  socketMessage: socketMessageReducer,
  notificationBadge,
  // configs,
  // error,

});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk), batchedSubscribe(debounceNotify))
);

export default store;